import { gql } from "@apollo/client";

export const DUPLICATE_INSURANCE_DOCUMENT = gql`
  mutation duplicateInsuranceDocument($input: DuplicateInsuranceDocumentInput!) {
    duplicateInsuranceDocument(input: $input) {
      commandId
      correlationId
    }
  }
`;
